import { FieldPath, useWatch } from 'react-hook-form';

import { selectHasArvOption } from '../../../redux/features/selectors/orderSelectors.ts';
import { useAppSelector } from '../../../redux/hooks.ts';
import { PropertyGridRow } from '../rows/PropertyGridRow.tsx';
import { TitleRow } from '../rows/TitleRow.tsx';
import {
  PropertyGridSectionProps as BasePropertyGridSectionProps,
  PropertyGridField,
  PropertyGridForm,
} from '../types.ts';

type PropertyGridSectionProps = BasePropertyGridSectionProps & {
  title: string;
  fields: PropertyGridField[];
};

export const PropertyGridSection = ({
  fields,
  title,
  isRemovable,
  onRemove,
  ...propertySectionProps
}: PropertyGridSectionProps) => {
  const hasArvOption = useAppSelector(selectHasArvOption);
  const { columnIndex, fieldTypes, feature, control, getValues } = propertySectionProps;

  const propertyId = useWatch({ control, name: `columns.${columnIndex}.propertyId` });
  const hasFeatureKey = feature === 'manualCost' ? 'hasManualCost' : `${feature}.hasFeature`;
  const featurePath = feature
    ? `columns.${columnIndex}.propertyData.editableData.improvements.${hasFeatureKey}`
    : `columns.${columnIndex}.propertyId`;
  const arvFeaturePath = feature
    ? `columns.${columnIndex}.propertyData.editableData.arv.improvements.${hasFeatureKey}`
    : `columns.${columnIndex}.propertyId`;

  const watchedValue: boolean = useWatch({
    control,
    name: featurePath as FieldPath<PropertyGridForm>,
  }) as boolean;
  const arvWatchedValue: boolean = useWatch({
    control,
    name: arvFeaturePath as FieldPath<PropertyGridForm>,
  }) as boolean;

  let sectionIsNone = false;
  let arvSectionIsNone = false;

  if (feature) {
    const hasFeature = watchedValue;
    if (hasArvOption && propertyId === 'subject') {
      const arvHasFeature = arvWatchedValue;
      if (!arvHasFeature) arvSectionIsNone = true;
    }

    if (!hasFeature) sectionIsNone = true;
  }

  return (
    <>
      <TitleRow
        columnIndex={columnIndex}
        fieldTypes={fieldTypes}
        title={title}
        feature={feature}
        isRemovable={isRemovable}
        onRemove={onRemove}
        control={control}
        getValues={getValues}
      />
      {fields.map((field) => (
        <PropertyGridRow
          key={field.label}
          field={field}
          sectionIsNone={sectionIsNone}
          arvSectionIsNone={arvSectionIsNone}
          {...propertySectionProps}
        />
      ))}
    </>
  );
};
